export const START_SUBMITTING = 'START_SUBMITTING';
export const STOP_SUBMITTING = 'STOP_SUBMITTING';

export const startSubmitting = (payload) => ({ type: START_SUBMITTING, payload });
export const stopSubmitting = () => ({ type: STOP_SUBMITTING });
